var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{staticClass:"forms-list"},_vm._l((_vm.data.rows),function(row){return _c('div',{key:row.id,staticClass:"forms-list__form",style:(_vm.rowStyle)},[_c('action-form',{attrs:{"id":row.id,"data":row,"type":_vm.entityType,"extActionsMeta":_vm.actionsMeta}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }